// extracted by mini-css-extract-plugin
export default {"screenCenter":"LoadingIndicator_screenCenter__O49el","loadingContainer":"LoadingIndicator_loadingContainer__goLmo"};